// utils/dateFormat.js
import { format } from 'date-fns';

export function formatDateForInput(dateInput) {
  if (!dateInput) return "";
  
  const dateObj = new Date(dateInput);
  if (isNaN(dateObj)) return "";
  
  return format(dateObj, 'yyyy-MM-dd'); // For HTML input type="date"
}

/**
 * Formats a given date for display purposes like "28 Apr 2025".
 * @param {string|Date|null} dateInput
 * @returns {string} Formatted human-readable date.
 */
export function formatDateForDisplay(dateInput) {
  if (!dateInput) return "";

  const dateObj = new Date(dateInput);
  if (isNaN(dateObj)) return "";

  return format(dateObj, 'dd MMM yyyy'); // Example: 28 Apr 2025
}
// Function to format time in 12-hour format with AM/PM
export const formatTime = (time) => {
  if (!time) return "";  // Return empty string if no time
  const date = new Date(time);  // Convert time to Date object if it's a string
  return format(date, "hh:mm a");  // Format as "hh:mm AM/PM"
};

